import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMountEffect } from '@react-hookz/web';
import { useEffect, useRef } from 'react';
import { Base } from '../../../../components/UpliftAds/components/Banner/components/Base.js';
import { Wrapper } from '../../../../components/UpliftAds/components/Banner/components/Wrapper.js';
export const Banner = ({
  onRender,
  onHasBeenVisible,
  onClick,
  className,
  category,
  content,
  width,
  height,
  ...props
}) => {
  const ref = useRef(null);
  // Make a GET request on this URL when an ad has been delivered to a user on the site.
  // This must be made for each and every ad displayed
  useMountEffect(() => {
    onRender();
  });
  // Make a GET request on this URL when the ad is in-view on the page.
  // In-view is classified as 50% of ad in-view for over 1 second.
  useEffect(() => {
    let timeoutId;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        timeoutId = setTimeout(() => {
          onHasBeenVisible();
          observer.disconnect();
        }, 1000);
      } else {
        clearTimeout(timeoutId);
      }
    }, {
      threshold: 0.5 // trigger when 50% of the element is visible
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      clearTimeout(timeoutId);
      observer.disconnect();
    };
  }, [onHasBeenVisible]);
  return _jsx(Wrapper, {
    ref: ref,
    className: className,
    width: width,
    height: height,
    onClick: onClick,
    children: _jsx(Base, {
      ...props,
      category: category,
      content: content
    })
  });
};